var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"calculator"}},[_c('h2',{staticClass:"display-3 mt-3 mb-3"},[_vm._v("Calculadora")]),_c('Calculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }